// @ts-nocheck
import { createContext } from 'react';
import { Localization } from '../models/localization';

const LocalizationContext = createContext<Localization>(null);

export default LocalizationContext;
